import script from "./subscriptionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./subscriptionCard.vue?vue&type=script&setup=true&lang=js"

import "./subscriptionCard.vue?vue&type=style&index=0&id=5f50a862&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f50a862"]])

export default __exports__